import { render, staticRenderFns } from "./InterviewCategories.vue?vue&type=template&id=505c0ab2&scoped=true"
import script from "./InterviewCategories.vue?vue&type=script&lang=js"
export * from "./InterviewCategories.vue?vue&type=script&lang=js"
import style0 from "./InterviewCategories.vue?vue&type=style&index=0&id=505c0ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c0ab2",
  null
  
)

export default component.exports